import React from 'react';
import { Button, Modal, connectModal } from '@gsa/afp-component-library';
import { z } from 'zod';
import { FormGenerator } from '@gsa/afp-shared-form-utils';

const FillExistingVehicleModal = ({ handleCancel, handleVehicleSubmit }) => {
  const schema = z.object({
    comment: z
      .string()
      .min(1, 'This is a required field')
      .max(1000, 'Comment exceeds the 1000 character limit'),
  });

  const content = {
    buttonControls: { submit: false, cancel: false },
    sections: [
      {
        fields: [
          {
            id: 'comment',
            type: 'textarea',
            label: 'Vehicle details',
            required: true,
            help: {
              after: '1000 characters allowed',
            },
            element: {
              control: {
                maxLength: 1000,
              },
            },
          },
        ],
      },
    ],
  };

  return (
    <Modal
      onClose={handleCancel}
      actions={
        <>
          <Button
            type="button"
            variant="unstyled"
            onClick={handleCancel}
            label="Cancel"
            className="padding-right-2"
          />
          <Button
            type="submit"
            variant="primary"
            leftIcon={{ name: 'check' }}
            label={'Continue'}
            form="fill-vehicle-modal"
          />
        </>
      }
    >
      <h2 className="font-body-md">
        Provide vehicle details, including VIN, that will fill this request.
      </h2>
      <FormGenerator
        className="margin-top-2"
        id="fill-vehicle-modal"
        schema={schema}
        content={content}
        onSubmit={(data) => handleVehicleSubmit(data)}
      />
    </Modal>
  );
};

export default connectModal(FillExistingVehicleModal);
